import {
  FormikErrors,
  FormikProps,
  FormikTouched,
  useFormikContext,
} from "formik";
import React, { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { AppContext } from "../../appContext/AppContext";
import { removeEventEnter } from "../../utils/AppFunction";
import { CODE, ID_DANG_KY_KHAM, KEY, KEY_DS_DANH_MUC_TIEP_DON, VARIABLE_STRING } from "../../utils/Constant";
import { formatDateDTO, handleAgeCalculate } from "../../utils/FormatUtils";
import {PhanHeTiepNhanContext, PhanHeTiepNhanContextProvider} from "../PhanHeTiepNhan";
import TTHanhChinhV2 from "../components/tab-tiep-nhan/TTHanhChinhV2";
import TTKhamBenhV2 from "../components/tab-tiep-nhan/TTKhamBenhV2";
import {
  CODE_DOI_TUONG,
  defaultOptionSelect,
  initialValuesTiepDon,
} from "../constants/PhanHeTiepNhan";
import {
  ObjectSelectAutocomplete,
} from "../models/PhanHeTiepNhanModel";
import { IconButtonSave } from "../../component/IconSvg";
import { IDanhSachDanhMuc, ITiepDon } from "../models/TiepDonModel";
import DSBenhNhan from "../components/tab-tiep-nhan/DSBenhNhan";
import { getByIdBenhNhan, inPhieuKham } from "../services/TiepNhanServices";
import { getIndexedDBItem } from "../../utils/IndexedDB";
import { DEFAULT_CODE_SELECT_TIEPDON } from "../constants/constants";
import ButtonInPhieu from "../../component/button-in-phieu";
import PageChiDinhDichVu from "../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/PageChiDinhDichVu";
import ModalNhapSoLuongInBarcode from "../../phan-he-xet-nghiem/components/tab-lay-mau-benh-pham/ModalNhapSoLuongInBarcode";
import { printEmployeeBarcode } from "../../phan-he-kham-doan/services/KhamDoanHopDongServices";
import {getDepartmentOpt} from "../util/FunctionUtil";
import useIndexDBValue from "../../../hook/useIndexDBValue";

export type benhNhanProps = {
  setActiveTab?:any
  values: ITiepDon;
  setFieldValue: (field: string, value: any) => void;
  handleInputChangeSinhHieu: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChecked?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors?: FormikErrors<ITiepDon>;
  touched?: FormikTouched<ITiepDon>;
  DSDichVu?: any[];
  setValues: (value: ITiepDon) => void;
  onAgeCalculate?: (DOB: string) => string;
  handleClearValue: (
    name: string,
    setFieldValue: (field: string, value: any) => void
  ) => void;
  handleChangeSelect: (
    selectedObject: ObjectSelectAutocomplete,
    name: string,
    setFieldValue: (field: string, value: any) => void
  ) => void;
  handleOpenTKBNDialog?: () => void;
  isDatLichHen?: boolean;
  handleChangeHenKham?: (value: boolean) => void;
  handleGenerateMaBenhNhan?: () => Promise<any>;
  resetForm?: () => void;
};

type TiepNhanProps = {
  openDSBenhNhan?: boolean,
  handleCloseDSBenhNhan?: () => void
}

const TiepNhan: FC<TiepNhanProps> = ({
  openDSBenhNhan, handleCloseDSBenhNhan
}) => {
  const { setIsLoading } = useContext(AppContext);
  const {
    thongTinBenhNhan,
    setDSDichVu,
    DSDichVu,
    setThongTinBenhNhan,
    setOrderMain,
    convertDataBenhNhan,
    setPatientRenewToggle,
  } = useContext(PhanHeTiepNhanContext);
  const {
    handleSubmit,
    setValues,
    setTouched,
    setFieldValue,
    values,
    errors,
    touched,
    resetForm,
  } = useFormikContext<ITiepDon>();
  const { value: listCategory } = useIndexDBValue<IDanhSachDanhMuc>({key: KEY_DS_DANH_MUC_TIEP_DON,});
  const {DICH_VU_CONG_KHAM} = DEFAULT_CODE_SELECT_TIEPDON;

  const [isDatLichHen, setIsHanKham] = useState<boolean>(false);
  const [keyOpenPhieuIn, setKeyOpenPhieuIn] = useState<string>("");
  const [openDialogChiDinhDichVu, setOpenDialogChiDinhDichVu] = useState<boolean>(false);
  const [openPrintBarcode, setOpenPrintBarcode] = useState(false);

  const handleInputChangeSinhHieu = useCallback(
    (
      e: React.ChangeEvent<HTMLInputElement>,
      values: ITiepDon,
      setFieldValue: FormikProps<ITiepDon>["setFieldValue"]
    ) => {
      let { name, value, type } = e.target;
      let itemSinhHieu = {
        code: name,
        datatype: type,
        value: Number(value) > 0 && value,
        datetime: formatDateDTO(new Date().toString()),
      };
      setFieldValue(`obs.${name}`, itemSinhHieu);
    },
    []
  );

  const handleChecked = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, setFieldValue: FormikProps<ITiepDon>["setFieldValue"]) => {
      const { name, checked } = e.target;
      setFieldValue(`${name}`, checked);
    },
    []
  );

  const handleChangeSelect = useCallback(
    (
      selectedObject: ObjectSelectAutocomplete,
      name: string,
      setFieldValue: (field: string, value: any) => void
    ) => {
      switch (name) {
        case VARIABLE_STRING.GENDER:
          setFieldValue("person.gender", selectedObject);
          break;
        default:
          setFieldValue(`${name}`, selectedObject);
          break;
      }
    },
    []
  );

  const handleClearValue = useCallback(
    (name: string, setFieldValue: (field: string, value: any) => void) => {
      setFieldValue(`${name}`, defaultOptionSelect);
    },
    []
  );

  const handleClearForm = useCallback(async (
    setValues: (values: any) => void,
    setTouched: (touched: object) => void
  ) => {
    try {
      const res: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
      let listDoiTuong = res?.listDoiTuong || [];
      const listGioiTinh = res?.listGioiTinh || [];
      const listDanToc = res?.listDanToc || [];
      const listQuocTich = res?.listQuocTich || [];
      const listDKKham = res?.listDKKham || [];
      const listDichVu = listCategory?.listDichVu || [];
      const listDept = listCategory?.listPhongKham || [];

      const service = listDichVu?.find((item: any) => item?.code === DICH_VU_CONG_KHAM)
        || null;
      const dept = getDepartmentOpt(service, listDept || []);

      setValues({
        ...initialValuesTiepDon,
        visit: {
          ...initialValuesTiepDon.visit,
          visitObjectType: listDoiTuong?.find((item: any) => item?.code === CODE_DOI_TUONG.YEU_CAU) || null,
          visitType: listDKKham.find((item: any) => item?.id === ID_DANG_KY_KHAM.KHAM_BENH),
          service,
          dept
        },
        patient: {
          ...initialValuesTiepDon?.patient,
          ethnicity: listDanToc.find((item: any) => item?.code === DEFAULT_CODE_SELECT_TIEPDON.DAN_TOC_KINH),
          person: {
            ...initialValuesTiepDon?.patient?.person,
            ccountry: listQuocTich.find((item: any) => item?.code === DEFAULT_CODE_SELECT_TIEPDON.QUOC_TICH_VN),
            gender: listGioiTinh.find((item: any) => item?.code === DEFAULT_CODE_SELECT_TIEPDON.GIOI_TINH),
          },
        },
        orders: initialValuesTiepDon.orders,
      });
      setOrderMain(null);
      setTouched({});
    } catch (error) {
      console.error(error);
    } finally {
      setPatientRenewToggle((prev: boolean) => !prev);
    }
  }, [listCategory, setOrderMain, setPatientRenewToggle]);

  const [activeTab, setActiveTab] = useState("")
  const formTiepNhanRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    formTiepNhanRef.current && formTiepNhanRef.current.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
    })
  }, [activeTab]);

  const handleUpdateDataBenhNhan = useCallback(async (id: string) => {
    try {
      setIsLoading(true);
      const { data } = await getByIdBenhNhan(id);
      if (CODE.SUCCESS === data?.code) {
        let dataConverted = convertDataBenhNhan(data?.data);
        let orderMain = data?.data?.orders?.find((order: any) => order?.isClinical);
        if (orderMain) {
          setOrderMain(orderMain);
        }
        setValues({...dataConverted, insLookup: values?.insLookup});
        setThongTinBenhNhan({
          ...thongTinBenhNhan,
          isExamined: data?.data?.isExamined,
          isMedicalExamSvcPaid: data?.data?.isMedicalExamSvcPaid,
        });
      } else {
        toast.error("Xảy ra lỗi, vui lòng thử lại!");
      }
    } catch (error) {
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [convertDataBenhNhan, setIsLoading, setOrderMain, setValues, setThongTinBenhNhan, thongTinBenhNhan, values?.insLookup]);

  const handleNewPatient = useCallback(async () => {
    const appBody = document.getElementById("kt_app_body");

    if (document.activeElement !== appBody) {
      (document.activeElement as HTMLElement).blur();
      (appBody as HTMLElement).focus();
    }

    await handleClearForm(setValues, setTouched);
    setDSDichVu([]);
    setThongTinBenhNhan({
      ...thongTinBenhNhan,
      isExamined: false,
      isMedicalExamSvcPaid: false,
    });
  }, [handleClearForm, setValues, setTouched, setDSDichVu, thongTinBenhNhan, setThongTinBenhNhan]);
  
  const handlePressKeyShortcuts = useCallback((e: any) => {
    switch (e.key) {
      case KEY.F1:
        e.preventDefault();
        handleNewPatient();
        break;
      case KEY.F2:
        e.preventDefault();
        handleSubmit();
        break;
      case KEY.F3:
        e.preventDefault();
        if (values?.visit?.id) {
          setKeyOpenPhieuIn("F3");
        }
        break;
      case KEY.F4:
        e.preventDefault();
        if (values?.visit?.id) {
          setOpenPrintBarcode(true);
        }
        break;
      case KEY.F6:
        e.preventDefault();
        if (values?.visit?.id && !values?.visit?.stopped) {
          setOpenDialogChiDinhDichVu(true);
        }
        break;
      default: return;
    }
  }, [
    values?.visit?.id,
    values?.visit?.stopped,
    handleNewPatient,
    handleSubmit,
    setKeyOpenPhieuIn,
    setOpenPrintBarcode,
    setOpenDialogChiDinhDichVu
  ]);

  useEffect(() => {
    window.addEventListener("keydown", handlePressKeyShortcuts);
    return () => {
      window.removeEventListener("keydown", handlePressKeyShortcuts);
    };
  }, [handlePressKeyShortcuts]);

  // Memoize context value
  const contextProviderValue = useMemo(() => ({
    handleNewPatient
  }), [handleNewPatient]);

  // Memoize inline handlers để tránh re-render
  const handleInputChangeSinhHieuWrapper = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => handleInputChangeSinhHieu(e, values, setFieldValue),
    [handleInputChangeSinhHieu, values, setFieldValue]
  );

  const handleCheckedWrapper = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => handleChecked(e, setFieldValue),
    [handleChecked, setFieldValue]
  );

  const handleOpenPrintBarcode = useCallback(() => {
    setOpenPrintBarcode(true);
  }, []);

  const handleClosePrintBarcode = useCallback(() => {
    setOpenPrintBarcode(false);
  }, []);

  const handleOpenChiDinhDichVu = useCallback(() => {
    setOpenDialogChiDinhDichVu(true);
  }, []);

  const handleCloseChiDinhDichVu = useCallback(() => {
    setOpenDialogChiDinhDichVu(false);
  }, []);

  const handleChangeHenKham = useCallback((value: boolean) => {
    setIsHanKham(value);
  }, []);

  // Memoize inline objects
  const inPhieuKhamParams = useMemo(() => ({
    encounterId: values?.encounter?.id,
  }), [values?.encounter?.id]);

  const generalInfo = useMemo(() => ({
    patient: values?.patient,
    visit: values?.visit,
    encounter: values?.encounter,
    forTiepDon: true,
  }), [values?.patient, values?.visit, values?.encounter]);

  const printBarcodeParams = useMemo(() => ({
    patientId: values?.patient?.id,
  }), [values?.patient?.id]);

  return (
    <PhanHeTiepNhanContextProvider value={contextProviderValue}>
      <div className="d-flex">
        <Form className="receive overflow-auto" onSubmit={handleSubmit} onKeyDown={removeEventEnter}>
        <div className="form-tiep-nhan" ref={formTiepNhanRef} >
          <Row className="spaces p-10 bg-white">
            <TTHanhChinhV2
              values={values}
              setValues={setValues}
              setFieldValue={setFieldValue}
              handleInputChangeSinhHieu={handleInputChangeSinhHieuWrapper}
              errors={errors}
              touched={touched}
              onAgeCalculate={handleAgeCalculate}
              handleChangeSelect={handleChangeSelect}
              handleClearValue={handleClearValue}
              isDatLichHen={isDatLichHen}
              DSDichVu={DSDichVu}
              handleChecked={handleCheckedWrapper}
              resetForm={resetForm}
            />
          </Row>

            <div className="spaces w-100 d-flex justify-content-start mt-10 bg-white gap-6 py-10 pr-10 pl-13">
              <Button
                className="btn-blue-outlined-custom spaces min-w-140 mr-5"
                onClick={handleNewPatient}
              >
                <i className="bi bi-plus-lg color-blue-custom fs-4"></i>
                <span>Bệnh nhân mới (F1)</span>
              </Button>
              {!values?.visit?.stopped && (
                <Button className="btn-fill spaces min-w-86" type="submit">
                  <IconButtonSave />
                  {(values?.patient?.id && values?.visit?.id) ? (
                    <span>Cập nhật (F2)</span>
                  ) : (
                    <span>Lưu lại (F2)</span>
                  )}
                </Button>
              )}
              {(values?.patient?.id && values?.visit?.id) && (
                <ButtonInPhieu
                  label="In phiếu khám (F3)"
                  fetchExport={inPhieuKham}
                  params={inPhieuKhamParams}
                  className="min-w-80px spaces mx-4"
                  keyOpenPhieuIn={keyOpenPhieuIn}
                  setKeyOpenPhieuIn={setKeyOpenPhieuIn}
                  keyBtn={KEY.F3}
                />
              )}
              <Button
                onClick={handleOpenPrintBarcode}
                hidden={!(values?.patient?.id && values?.visit?.id)}
              >
                In barcode (F4)
              </Button>
              <Button
                className="btn-fill spaces min-w-100"
                onClick={handleOpenChiDinhDichVu}
                hidden={!values?.visit?.id || values?.visit?.stopped}
              >
                Chỉ định dịch vụ (F6)
              </Button>
            </div>

          <TTKhamBenhV2
            setActiveTab={setActiveTab}
            values={values}
            setFieldValue={setFieldValue}
            handleInputChangeSinhHieu={handleInputChangeSinhHieuWrapper}
            handleChecked={handleCheckedWrapper}
            errors={errors}
            touched={touched}
            DSDichVu={DSDichVu}
            setValues={setValues}
            handleChangeSelect={handleChangeSelect}
            handleClearValue={handleClearValue}
            isDatLichHen={isDatLichHen}
            handleChangeHenKham={handleChangeHenKham}
          />
        </div>
        </Form>

        {openDSBenhNhan && (
          <DSBenhNhan
            show={openDSBenhNhan}
            onHide={handleCloseDSBenhNhan as () => void}
            handleGetThongTinBenhNhan={handleUpdateDataBenhNhan}
            resetFormTiepDon={handleNewPatient}
          />
        )}

        {openDialogChiDinhDichVu && (
          <PageChiDinhDichVu
            show={openDialogChiDinhDichVu}
            handleClose={handleCloseChiDinhDichVu}
            generalInfo={generalInfo}
          />
        )}

        {openPrintBarcode && (
          <ModalNhapSoLuongInBarcode
            quantity={1}
            handleClose={handleClosePrintBarcode}
            params={printBarcodeParams}
            fetchExport={printEmployeeBarcode}
          />
        )}
      </div>
    </PhanHeTiepNhanContextProvider>
  );
};
export default TiepNhan;
